import React from 'react';
import HojaCaratula from './base/HojaCaratula';

const NOTA_HEREDADO =
    'Si el reconocimiento todavía no lo tiene, se trae de la Jubilación / Plan de Pago padre. Se guarda en el reconocimiento: el trámite padre no cambia.';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_reconocimiento.docx), que es
// la de Jubilación 24476 con otro título: los renglones son los mismos que esa variante en
// ModalCaratulaJubilacion. `guardable` marca los que además de imprimirse vuelven al
// cliente/trámite (ver CaratulaReconocimientoDocumentoService.persistirDatosGuardables).
const CAMPOS = {
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    liq: {
        label: 'LIQ', tipo: 'texto',
        nota: 'Viene de la fecha de liquidar del trámite. Lo que edites acá va solo al documento: para cambiarla de verdad, editala en la ficha del trámite (al lado de la carpeta).',
    },
    pacto: { label: 'PACTO', tipo: 'sino' },
    cuota: { label: 'CUOTA', tipo: 'texto', guardable: true, nota: NOTA_HEREDADO },

    claveFiscal: { label: 'CLAVE FISCAL', tipo: 'clave', guardable: true },
    claveCvss: { label: 'CLAVE CVSS', tipo: 'clave', guardable: true },
    referencia: { label: 'REFERENCIA', tipo: 'texto' },
    cidi: { label: 'CIDI', tipo: 'clave', guardable: true },

    apellidoNombre: { label: 'APELLIDO/NOMBRE', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    nacionalidad: { label: 'NACIONALIDAD', tipo: 'texto', guardable: true },
    domicilio: {
        label: 'DOMICILIO', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono: {
        label: 'Nº TELEFONICOS', tipo: 'texto',
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Se editan desde la ficha del cliente.',
    },
    mail: { label: 'MAIL', tipo: 'email', guardable: true },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },
    conyuge: { label: 'CON', tipo: 'texto', guardable: true },

    relacionDependencia: { label: 'RELACION DE DEPENDENCIA TOTAL', tipo: 'texto' },
    posterior1093: {
        label: '/ POSTERIOR AL 10/93', tipo: 'texto',
        nota: 'El sistema todavía no lo calcula. Lo que escribas acá va solo al documento.',
    },
    autonomoMonotributo: { label: 'AUTONOMO O MONOTRIBUTO', tipo: 'texto' },
    aportesProvincia: { label: 'APORTES PROVINCIALES', tipo: 'sino', guardable: true, nota: NOTA_HEREDADO },
    cuentaAfip: { label: 'CUENTA EN AFIP', tipo: 'texto', guardable: true, nota: NOTA_HEREDADO },
    planesVigentes: { label: 'PLANES VIGENTES', tipo: 'texto', guardable: true, nota: NOTA_HEREDADO },

    observaciones: { label: 'OBSERVACIONES', tipo: 'multilinea', guardable: true },
    liquidar: {
        label: 'LIQUIDAR', tipo: 'texto', guardable: true,
        nota: 'Se prellena con la fecha de liquidar del trámite si está vacío. Admite texto libre ("a coordinar"). Guardarlo no modifica esa fecha.',
    },
};

// Una sola plantilla, así que la distribución es fija. Un array de 1 key = renglón simple;
// de 2 = dos columnas.
const CAJAS_CABECERA = [['ingreso', 'liq'], ['pacto', 'cuota']];
const FILA_CLAVES = ['claveFiscal', 'claveCvss'];
const FILA_REFERENCIA = ['referencia', 'cidi'];
const FILAS_CUERPO = [
    ['apellidoNombre'],
    ['dniCuit'],
    ['fechaNacimiento'],
    ['nacionalidad'],
    ['domicilio'],
    ['telefono'],
    ['mail'],
    ['estadoCivil', 'conyuge'],
    ['relacionDependencia', 'posterior1093'],
    ['autonomoMonotributo'],
    ['aportesProvincia'],
    ['cuentaAfip'],
    ['planesVigentes'],
    ['observaciones'],
    ['liquidar'],
];

// Cómo se dibuja la hoja: título del documento, las cajitas de arriba, los renglones que
// van fuera del recuadro y el bloque principal. HojaCaratula pone el resto (modal, aviso,
// hoja A4 y botones), que es igual en todas las carátulas.
const LAYOUT = {
    tituloDoc: 'DATOS PERSONALES',
    leyendaDoc: 'Reconocimiento de servicios',
    cabecera: CAJAS_CABECERA,
    filasPrevias: [FILA_CLAVES, FILA_REFERENCIA],
    cuerpo: FILAS_CUERPO,
};

/**
 * Modal de la Carátula de Reconocimiento de Servicios. Muestra los renglones prellenados (lo
 * que ya está en el cliente/trámite, lo heredado del trámite padre, o calculado desde los
 * aportes) y en blanco lo que falta, para completar antes de generar. Al confirmar, "Guardar
 * y generar" persiste los renglones guardables y emite el .docx con el DTO tal cual quedó en
 * el formulario (WYSIWYG).
 */
export default function ModalCaratulaReconocimiento(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula de Reconocimiento de Servicios"
            nombreDocumento="la Carátula de Reconocimiento de Servicios"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
